import { useState } from "react";
import style from "./style.module.scss";
import { Form } from "react-bootstrap";
import WriteComment from "../Comments/WriteComment";
import CommentSingle from "../Comments/Single";
import useFormat from "../../hooks/utils/useFormat";
import Checkbox2 from "../Checkbox2";

export default function ActivityLogs(props) {
  const { activity, messageItem, handlemessage, saveMessage } = props;
  const { formatDate } = useFormat();

  const [filter, setfilter] = useState({
    activity: true,
    comments: true,
  });

  return (
    <>
      <div className="text-center mt-2">
        <p className={style.title}>
          <span>Atividades e Comentários</span>
        </p>
      </div>
      <div className="mb-4">
        <Checkbox2
          checked={filter?.activity}
          onChange={() => {
            setfilter(__ev => ({ ...__ev, activity: !__ev?.activity }));
          }}
          label="Atividades"
        />
        <Checkbox2
          checked={filter?.comments}
          onChange={() => {
            setfilter(__ev => ({ ...__ev, comments: !__ev?.comments }));
          }}
          label="Comentários"
        />
      </div>
      {!!filter?.comments && (
        <div className="mb-4">
          <Form.Group>
            <WriteComment
              value={messageItem}
              onChange={handlemessage}
              name="description"
              placeholder="Adicione o seu comentário"
              buttonClick={saveMessage}
            />
          </Form.Group>
        </div>
      )}
      <ul className="logFeed m-0 p-0">
        {activity.length > 0 &&
          activity.map(item =>
            item.type === "msg" ? (
              <>
                {!!filter?.comments && (
                  <CommentSingle
                    username={item?.user?.username}
                    message={item?.message}
                    created_at={item?.created_at}
                    className={style.item}
                  />
                )}
              </>
            ) : (
              <>
                {!!filter?.activity && (
                  <li className={`${style.item} ${style.status}`}>
                    <p className={item?.message === "Contrato fechado!" ? "congrats" : ""}>
                      <div dangerouslySetInnerHTML={{ __html: item?.message }} />
                      <span className="mb-1 fw-bold">{item?.user?.username}</span>
                      <span>{formatDate(item.created_at, 4)}</span>
                    </p>
                  </li>
                )}
              </>
            ),
          )}
      </ul>
    </>
  );
}
